import SearchInput from './SearchInput.vue'

export default SearchInput



// WEBPACK FOOTER //
// ./src/app/components/common/searchInput/index.js